module.exports = __webpack_public_path__ + "static/img/servicecenter__bg-t.fb6c790a.jpg";